module.exports = __webpack_public_path__ + "assets/img/20_972.1951ad3a.jpg";